import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Linkedin, MessageSquare } from 'lucide-react';

export const ContactSection = () => {
  return (
    <section id="contact" className="py-20 md:py-28 bg-secondary/30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Let&apos;s Connect
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto rounded-full mb-6" />
          <p className="text-muted-foreground text-base sm:text-lg max-w-xl mx-auto">
            If you&apos;d like to connect or discuss opportunities, I&apos;d love to hear from you.
          </p>
        </div>

        {/* Contact Card */}
        <Card className="bg-card border-border shadow-xl">
          <CardContent className="p-8 md:p-10">
            <div className="flex flex-col items-center text-center">
              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-primary-soft flex items-center justify-center mb-6">
                <MessageSquare className="w-8 h-8 text-primary" />
              </div>
              
              {/* Message */}
              <p className="text-muted-foreground mb-8 max-w-md">
                The best way to reach me is through LinkedIn. I&apos;m always open to discussing 
                new opportunities, technology trends, or just connecting with fellow professionals.
              </p>

              {/* LinkedIn Button */}
              <Button 
                variant="primary" 
                size="lg"
                asChild
                className="w-full sm:w-auto"
              >
                <a 
                  href="https://www.linkedin.com/in/narekonanyan" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2"
                >
                  <Linkedin size={20} />
                  Connect on LinkedIn
                </a>
              </Button>

              {/* Additional info */}
              <p className="text-sm text-muted-foreground mt-6">
                Based in Los Angeles, CA
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ContactSection;
